import { defineStore } from 'pinia';
import IUrlHistoryItem from '@/interfaces/IUrlHistoryItem';
import HISTORICAL_URLS_LOCAL_STORAGE_KEY from '@/constants/HistoricalUrlsLocalStorageKey';
import { useStorage } from '@vueuse/core';
import { useActiveUrlStore } from '@/store/activeUrlStore';
import Provider from '@/enums/Provider';

export const useUrlHistoryStore = defineStore('urlHistory', {
  state: () => ({
    urls: useStorage<IUrlHistoryItem[]>(
      HISTORICAL_URLS_LOCAL_STORAGE_KEY,
      new Array<IUrlHistoryItem>()
    ),
  }),
  actions: {
    addUrl(baseUrl: string) {
      const newUrl: IUrlHistoryItem = {
        baseUrl,
        updatedOn: undefined,
        provider: undefined,
        createdOn: new Date(),
      };
      // Set the active URL to the newly added URL
      const activeUrlStore = useActiveUrlStore();
      activeUrlStore.setActiveUrl(baseUrl);
      this.urls.push(newUrl);
    },
    updateUrl(baseUrl: string) {
      const url = this.findUrl(baseUrl);
      if (url) {
        url.updatedOn = new Date();

        // Set the active URL to the updated URL
        const activeUrlStore = useActiveUrlStore();
        activeUrlStore.setActiveUrl(baseUrl);
      }
    },
    existsUrl(baseUrl: string): boolean {
      return !!this.findUrl(baseUrl);
    },
    removeUrl(baseUrl: string) {
      this.urls = this.urls.filter((url) => url.baseUrl !== baseUrl);
    },
    updateProvider(baseUrl: string, provider: Provider) {  // Renamed from updateIsKbs
      const url = this.findUrl(baseUrl);
      if (url) {
        url.provider = provider;
        url.updatedOn = new Date();
      }
    },
    findUrl(baseUrl: string): IUrlHistoryItem | undefined {
      return this.urls.find((url) => url.baseUrl === baseUrl);
    },
  },
});
